<template>
  <div>
    <div class="profile-header mb-10">
      <div class="relative">
        <div class="cover-container rounded-t-lg">
          <img
            src="@/assets/images/experiences/real_world_experience/cover_photo.jpg"
            alt=""
            class="responsive block"
          />
        </div>
      </div>
    </div>
    <vx-card>
      <div>
        <heading size="h1" style-size="h4">"Real World" Experience</heading>
        <p class="my-5">Enter the details of where and when you will be doing Work Experience.</p>
        <p class="my-5"><strong>Please Note:</strong></p>
        <p class="my-5">
          1. You must enter the host business name carefully and accurately. Check spelling and
          appropriate capital letters. What you enter here is what will appear on your final Work
          Experience certificate.
        </p>
        <p class="my-5">2. Your Work Experience end date must be <u>AFTER</u> your start date.</p>

        <form id="form">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-2/3 w-full">
              <label>
                Host Business Name:
                <vs-input
                  class="w-full"
                  v-model="data.business_name"
                  aria-required="true"
                  required
                />
              </label>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-2/3 w-full">
              <accessible-datepicker
                :label="'Work Experience Start Date:'"
                :required="true"
                @input-date="setStartDate"
                name="start-date"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-2/3 w-full">
              <accessible-datepicker
                :label="'Work Experience End Date:'"
                :required="true"
                @input-date="setEndDate"
                name="end-date"
              />
            </div>
          </div>
          <button class="btn btn-primary btn-size-medium" @click.prevent="startExperienceConfirm">
            Start Experience
          </button>
        </form>
      </div>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';
import router from '@/router/router';
import AccessibleDatepicker from '@/components/AccessibleDatepicker';

export default {
  components: {
    AccessibleDatepicker,
  },
  data() {
    return {
      data: {
        business_name: '',
        start_date: null,
        end_date: null,
      },
    };
  },
  methods: {
    setStartDate(date) {
      this.data.start_date = date;
    },
    setEndDate(date) {
      this.data.end_date = date;
    },
    startExperienceConfirm() {
      const vm = this;

      let title = `Start 'Real World' Work Experience?`;
      let color = 'primary';
      let text = 'Are you sure you want to start this Work Experience?';

      this.$vs.dialog({
        type: 'confirm',
        color: color,
        title: title,
        text: text,
        accept: async function () {
          await vm.startExperience();
        },
      });
    },
    async startExperience() {
      await store.dispatch('authStudent/addRealWorldExperience', this.data);
    },
  },
  computed: {
    settings() {
      return store.getters['authStudent/settings'];
    },
  },
  mounted() {
    if (
      typeof this.settings['work_experience_real'] !== 'undefined' &&
      this.settings['work_experience_real'] == false
    ) {
      router.push('/student/dashboard');
    }
  },
};
</script>
